import axios from 'axios';
import { createAuthInterceptor } from './interceptors/authInterceptor';

// @ts-ignore - Runtime env from config.js
const baseURL = window.ENV?.REACT_APP_PYTHON_AI_SERVICE_URL || process.env.REACT_APP_PYTHON_AI_SERVICE_URL || 'https://euaiaudit.pke-dev.providus.rs/api/v1/python-ai';

const PythonAIAPI = axios.create({
  baseURL,
  withCredentials: true
});

// Setup auth interceptor for Python AI service
const authInterceptor = createAuthInterceptor(PythonAIAPI);
PythonAIAPI.interceptors.response.use(
  authInterceptor.response,
  authInterceptor.responseError
);

export default PythonAIAPI;
